import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useWindowSize } from "go-core/components/useWindowSize";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import { FormDirty } from "go-form/components/FormDirty";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { CorrectionFullApi } from "../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../services/Api/api";

const CorrectionFullForm = () => {
	const [loading, setLoading] = useState(false);
	const form = useForm<CorrectionFullApi>({
		criteriaMode: "all",
		defaultValues: {},
	});
	const { formState, handleSubmit, setError } = form;
	const {
		formState: { errors },
		control,
	} = form;
	const { t } = useTranslation();
	const { addFlash, addSuccessFlash } = useFlash();

	const isMobile = useWindowSize().isMobile;

	const searchProducts = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return api.organization().getProductSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};
	const onSubmit = handleSubmit(async (data: CorrectionFullApi) => {
		setLoading(true);
		try {
			const res = await api.organization().correctionFull(data);
			addSuccessFlash(t("lib:common.flash.completed"));
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<>
			<h5 className={isMobile ? "mt-2" : "mt-0"}>{t("lib:common.word.basic_data")}</h5>
			<FormDirty formState={formState} onSubmit={onSubmit} loading={loading} className="jpk-form">
				<fieldset className="form-group">
					<div className="row">
						<div className="col-md-12">
							<FormDatePicker errors={errors} control={control} name={"date_from"} label={"Data od"} />
						</div>
						<div className="col-md-12">
							<FormSelectGroup
								isMulti
								control={control}
								loadOptions={searchProducts}
								label={"Produkt"}
								name="product_ids"
								isClearable={false}
								getOptionValue={(opt) => opt.id}
								errors={errors}
							/>
						</div>
					</div>
				</fieldset>
			</FormDirty>
		</>
	);
};

export default CorrectionFullForm;
